module.exports = __webpack_public_path__ + "img/BPPMP3.c0a24677.png";